import { render } from "./UpdateAccessModal.vue?vue&type=template&id=319a635d&scoped=true&lang=pug"
import script from "./UpdateAccessModal.vue?vue&type=script&lang=js"
export * from "./UpdateAccessModal.vue?vue&type=script&lang=js"

import "./UpdateAccessModal.vue?vue&type=style&index=0&id=319a635d&scoped=true&lang=scss"

import exportComponent from "/builds/wiwdata/applications/finance-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-319a635d"]])

export default __exports__